import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { ErrorLoggingService } from "../../services/error-logging.service";

@Injectable()
export class CustomErrorHandler extends ErrorHandler
{

    constructor(
        private injector: Injector,
        private loggingService: ErrorLoggingService,
    )
    {
        super();
    }

    // provide whatever behavior you want to handle the error
    handleError(error)
    {

        super.handleError(error); // throws error - original behavior

        const location = this.injector.get(LocationStrategy);
        const stack = error.stack;
        const url = location instanceof PathLocationStrategy
            ? location.path() : "";

        // logs error to server
        this.loggingService.logError(`${ stack }\nURL: ${ url }`);

    }
}
